import React from 'react'
import TextField from '@material-ui/core/TextField'
import {Entry} from '../entries/Entries'
import {Button} from '@material-ui/core'
import './Journal.css'
import {db} from '../../firebase'
import firebase from 'firebase'

class Journal extends React.Component {
	state = {
		input: '',
		texts: [],
		username: '',
		text: [],
	}

	async componentDidMount() {
		const currentUser = await firebase.auth().currentUser;
		if (currentUser) {
			this.setState({username: currentUser.uid});
		}
		this.updateEntries();
	}

	updateEntries() {
		db.collection('entries')
			.where("username", "==", this.state.username)
			.orderBy('timestamp', 'desc')
			.onSnapshot((snapshot) => {
				const journalInfo = snapshot.docs.map((doc) => ({id: doc.id, text: doc.data()}));
				this.setState({texts: journalInfo})
			})
	}


	addEntry = (evt) => {
		db.collection('entries').add({
			text: this.state.input,
			username: this.state.username,
			timestamp: firebase.firestore.FieldValue.serverTimestamp()
		})

		this.setState({input: ''});
		this.updateEntries();
	}

	deleteEntry = (id) => {
		db.collection("entries").doc(id).delete().then(() => {
			console.log("Document successfully deleted!");
			this.updateEntries();
		}).catch(function (error) {
			console.error("Error removing document: ", error);
		});
	}

	setInput = (e) => {
		this.setState({input: e.target.value});
	}

	render() {
		return (
			<div className='wrapper'>
				<div className='journal__container'>
					<span className='welcome'> Daily Reflection's</span>
					<span className='journal_text'>What's on your mind today?</span>
					<form className='form__container'>
						<TextField
							className='journal_input'
							multiline
							rowsMax={4}
							value={this.state.input}
							onChange={(evt) => this.setInput(evt)}
						/>
						<div className='button'>
							<Button
								className='journal__button'
								type='button'
								disabled={!this.state.input}
								onClick={this.addEntry}
							>
								{' '}
								Submit Entry
							</Button>
						</div>
					</form>
					<div className='card__content'>
						{this.state.texts.map(({id, text}) => (
							<Entry key={id} id={id} deleteEntry={this.deleteEntry}
							       username={this.state.username} text={text}/>
						))}
					</div>
				</div>
			</div>
		)
	}
}

export {Journal}
